export const userEditSteps = [
    {
    target: ".u_edit-name",
    content:
      "You're editing an existing user. The name shown here is the user being updated.",
    placement: "bottom",
  },
    {
    target: ".j_u_bBtn",
    content:
      "Click here to go back to the full list of users without saving your current changes.",
    placement: "bottom",
  },

  {
    target: ".j_u_ac_mtr",
    content:
      "Indicates the user's current access level (e.g., Low, Medium, High).",
    placement: "bottom",
  },

  {
    target: ".j_u_save",
    content: "Click 'Save' to update the user and remain on this page.",
    placement: "left",
  },
  {
    target: ".j_u_sa_cl",
    content: "Click 'Save & Close' to update and return to the user list.",
    placement: "left",
  },
];
export const userEditDetailsSteps = [
  {
    target: ".j_u_details",
    content:
      "You're in the 'Details' tab, where you can modify core information of the selected user.",
    placement: "bottom",
  },
      {
    target: ".j_u_appReq",
    content:
      "Check this if you want the user to have access of approving requests.",
    placement: "bottom",
  },
    {
    target: ".j_u_status",
    content:
      "Toggle the user's status to activate or deactivate access as needed.",
    placement: "bottom",
  },
  {
    target: ".j_u_uNam",
    content:
      "This shows the existing username pulled from Active Directory. It’s typically not editable.",
    placement: "bottom",
  },
  {
    target: ".j_u_ad_tgl",
    content:
      "This toggle indicates whether the user is linked with Active Directory. Adjust only if required.",
    placement: "bottom",
  },
  {
    target: ".j_u_ap_acc",
    content:
      "Modify the application access level for this user — e.g., standard 'User' or elevated 'Admin'.",
    placement: "bottom",
  },
  {
    target: ".j_u_fname",
    content:
      "You can update the user's first name here if corrections are needed.",
    placement: "bottom",
  },
  {
    target: ".j_u_lname",
    content:
      "Change or add the user's last name for more accurate identification.",
    placement: "bottom",
  },
  {
    target: ".j_u_mail",
    content:
      "Update the user's email if there are changes. Ensure the address is valid and active.",
    placement: "bottom",
  },
  {
    target: ".j_u_mngr",
    content:
      "Update the reporting manager if the reporting structure has changed.",
    placement: "bottom",
  },
    {
    target: ".j_u_crPass",
    content:
      "Create the password for the user.",
    placement: "bottom",
  },  {
    target: ".j_u_cPass",
    content:
      "Confirm the password being created.",
    placement: "bottom",
  },

];

export const userEditRoleSteps = [
  {
    target: ".j_u_roles",
    content:
      "This 'Roles' tab lets you manage and adjust the roles assigned to the user.",
    placement: "bottom",
  },
{
    target: ".j_srch",
    content:
      "Filter results based on name, ID, or other attributes depending on the field.",
    placement: "bottom",
  },
  {
    target: ".j_fil",
    content:
      "Filter roles by geography, business units, and more to find relevant ones quickly.",
    placement: "bottom",
  },
  {
    target: ".j_u_rT_assigned",
    content:
      "This section lists roles currently assigned to the user. You can unassign them if needed.",
    placement: "bottom",
  },
  {
    target: ".j_u_rT_available",
    content:
      "Use this area to view and assign new roles to the user based on requirements.",
    placement: "bottom",
  },
  {
    target: ".j_u_rT_groups",
    content:
      "Assign or modify Security Groups associated with this user here.",
    placement: "bottom",
  },
  {
    target: ".j_g_rt_copy",
    content:
      "Copy roles from another user or template to update this user’s roles efficiently.",
    placement: "top",
  },
];
export const userEditReportSteps = [
  {
    target: ".j_u_rep",
    content:
      "This 'Scheduled Reports' tab shows reports in which the user is currently configured as a recipient.",
    placement: "bottom",
  },
  {
    target: ".j_u_r_srch",
    content:
      "Use this search to quickly locate a specific scheduled report by its name.",
    placement: "bottom",
  },
  {
    target: ".g_rt_user",
    content:
      "This notice explains that some reports are automatically assigned and include the user.",
    placement: "bottom",
  },
  {
    target: ".j_u_r_card",
    content:
      "Each card summarizes a scheduled report's details, such as its name and setup date.",
    placement: "bottom",
  },
  {
    target: ".j_u_r_rem",
    content:
      "This icon confirms that the user is an active recipient of the given report.",
    placement: "left",
  },
];


